import { fromDomEvent, interval, merge, pipe, take, tap } from 'wonka';

export const domContentLoaded$ = (globalScope: Window) =>
  pipe(
    merge<number | Event>([
      fromDomEvent(globalScope as unknown as HTMLElement, 'DOMContentLoaded'),
      interval(10),
    ]),
    // We're using this as a race condition, take the first event emitted to
    take(1),
  );

export const resize$ = (globalScope: Window) =>
  fromDomEvent(globalScope as unknown as HTMLElement, 'resize');

export const unload$ = (globalScope: Window) =>
  fromDomEvent(globalScope as unknown as HTMLElement, 'unload');
